"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressTextFields = AddressTextFields;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _StateDropdown = _interopRequireDefault(require("../StateDropdown"));

var _ZipInput = _interopRequireDefault(require("../NumberInputs/ZipInput"));

var _translations = require("../../helpers/translations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AddressTextFields(_ref) {
  var address = _ref.address,
      _ref$addressSuggestio = _ref.addressSuggestions,
      addressSuggestions = _ref$addressSuggestio === void 0 ? [] : _ref$addressSuggestio,
      autocompleteProps = _ref.autocompleteProps,
      autocompleteSuggestionsGet = _ref.autocompleteSuggestionsGet,
      autocompleteText = _ref.autocompleteText,
      errorGet = _ref.errorGet,
      inputProps = _ref.inputProps,
      _ref$isReadOnly = _ref.isReadOnly,
      isReadOnly = _ref$isReadOnly === void 0 ? address.Country !== 'US' && address.Country !== '' : _ref$isReadOnly,
      onAutocompleteAddressSelect = _ref.onAutocompleteAddressSelect,
      onInputChange = _ref.onInputChange,
      stateFormControlProps = _ref.stateFormControlProps,
      textFieldProps = _ref.textFieldProps,
      usStates = _ref.usStates;
  return isReadOnly ? [address.StreetAddress1 && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.StreetAddress1, "_StreetAddress1")
  }, address.StreetAddress1), address.StreetAddress2 && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.StreetAddress2, "_StreetAddress2")
  }, address.StreetAddress2), address.StreetAddress3 && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.StreetAddress3, "_StreetAddress3")
  }, address.StreetAddress3), address.City && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.City, "_City")
  }, address.City), address.State && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.State, "_State")
  }, address.State), address.PostalCode && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.PostalCode, "_PostalCode")
  }, address.PostalCode), address.CountryName && /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(address.CountryName, "_CountryName")
  }, address.CountryName)] : [/*#__PURE__*/_react["default"].createElement(_material.Autocomplete, _extends({
    disableClearable: true // The built-in clear button works inconsistently, so disabling this for now. User can still use keyboard to remove text.
    ,
    filterOptions: function filterOptions(options) {
      return options;
    } // Prevents Autocomplete from filtering out any options
    ,
    freeSolo: true,
    getOptionLabel: function getOptionLabel(option) {
      return option.street_line ? "".concat(option.street_line, " ").concat(option.secondary, " ").concat(option.city, ", ").concat(option.state, " ").concat(option.zipcode) : address.StreetAddress1;
    },
    includeInputInList: true,
    inputValue: autocompleteText,
    key: "searchSuggestions",
    onChange: function onChange(event, newValue) {
      return onAutocompleteAddressSelect(event, newValue);
    },
    options: addressSuggestions,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({
        error: Boolean(errorGet('StreetAddress1')),
        fullWidth: true,
        helperText: errorGet('StreetAddress1'),
        label: (0, _translations.getTranslations)('address_street_1_lbl'),
        onChange: function onChange(e) {
          return autocompleteSuggestionsGet(e);
        },
        value: autocompleteText
      }, params, textFieldProps));
    }
  }, autocompleteProps)), /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({
    error: Boolean(errorGet('StreetAddress2')),
    fullWidth: true,
    helperText: errorGet('StreetAddress2'),
    inputProps: _objectSpread({
      maxLength: 40
    }, inputProps),
    key: "StreetAddress2",
    label: (0, _translations.getTranslations)('address_street_2_lbl'),
    name: "StreetAddress2",
    onChange: function onChange(e) {
      return onInputChange('StreetAddress2', e);
    },
    value: address.StreetAddress2
  }, textFieldProps)), /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({
    error: Boolean(errorGet('City')),
    fullWidth: true,
    helperText: errorGet('City'),
    inputProps: _objectSpread({
      maxLength: 30
    }, inputProps),
    key: "City",
    label: (0, _translations.getTranslations)('address_city_lbl'),
    name: "City",
    onChange: function onChange(e) {
      return onInputChange('City', e);
    },
    value: address.City
  }, textFieldProps)), /*#__PURE__*/_react["default"].createElement(_StateDropdown["default"], {
    errorText: errorGet('State'),
    fullWidth: true,
    key: "State",
    name: "State",
    onChange: function onChange(value) {
      return onInputChange('State', {
        target: {
          value: value
        }
      });
    },
    SelectProps: _objectSpread({}, inputProps),
    states: usStates,
    value: address.State || '',
    FormControlProps: _objectSpread({}, stateFormControlProps)
  }), /*#__PURE__*/_react["default"].createElement(_ZipInput["default"], _extends({
    error: Boolean(errorGet('PostalCode')),
    fullWidth: true,
    helperText: errorGet('PostalCode'),
    inputProps: _objectSpread({}, inputProps),
    key: "Postal Code",
    label: (0, _translations.getTranslations)('address_postal_code_lbl'),
    name: "PostalCode",
    onChange: function onChange(e) {
      return onInputChange('PostalCode', {
        target: {
          value: e.value
        }
      });
    },
    value: address.PostalCode
  }, textFieldProps))];
}

var _default = AddressTextFields;
exports["default"] = _default;
AddressTextFields.propTypes = {
  address: _propTypes["default"].shape({
    City: _propTypes["default"].string,
    Country: _propTypes["default"].string,
    CountryName: _propTypes["default"].string,
    PostalCode: _propTypes["default"].string,
    State: _propTypes["default"].oneOfType([_propTypes["default"].shape({
      Code: _propTypes["default"].string,
      Name: _propTypes["default"].string
    }), _propTypes["default"].string]),
    StreetAddress1: _propTypes["default"].string,
    StreetAddress2: _propTypes["default"].string,
    StreetAddress3: _propTypes["default"].string
  }).isRequired,
  addressSuggestions: _propTypes["default"].array,
  isReadOnly: _propTypes["default"].bool,
  stateFormControlProps: _propTypes["default"].any,
  textFieldProps: _propTypes["default"].any,
  autocompleteProps: _propTypes["default"].any,
  autocompleteSuggestionsGet: _propTypes["default"].func.isRequired,
  autocompleteText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  errorGet: _propTypes["default"].func,
  inputProps: _propTypes["default"].shape({
    /* Any props available on a text input or select input (for State) can be added here. */
    disabled: _propTypes["default"].bool,

    /* Example only - not required to be included */
    readOnly: _propTypes["default"].bool
    /* Example only - not required to be included */

  }),
  onAutocompleteAddressSelect: _propTypes["default"].func.isRequired,
  onInputChange: _propTypes["default"].func,
  usStates: function usStates(props) {
    _propTypes["default"].arrayOf(_propTypes["default"].shape({
      Code: _propTypes["default"].string,
      Name: _propTypes["default"].string
    })).isRequired;

    if (!props.isReadOnly && !props.usStates) {
      return new Error('usStates required for <StateDropdown /> in format [{ Code: "UT", Name: "Utah" }]');
    }
  }
};